module.exports = __webpack_public_path__ + "img/Rotkreuzbeauftragter.e42bc94d.svg";